<app-header title="Event"/>

<ion-content [fullscreen]="true">
  @if (isLoading) {
    <app-container>
      <ion-list class="mt-6">
        <ion-item lines="none">
          <ion-skeleton-text [animated]="true"/>
        </ion-item>
        <ion-item lines="none">
          <ion-skeleton-text [animated]="true"/>
        </ion-item>
        <ion-item lines="none">
          <ion-skeleton-text [animated]="true"/>
        </ion-item>
      </ion-list>
    </app-container>
  } @else {
    @if (!event().id) {
      <app-container>
        <div class="flex items-center justify-center h-64">
          <ng-icon name="heroCalendarDays" size="10rem" class="text-gray-300"/>
        </div>
        <div class="text-center">
          <h2 class="text-xl font-bold">Event nicht gefunden</h2>
          <p class="text-gray-600">Das Event konnte nicht gefunden werden.</p>
        </div>
      </app-container>
    } @else {

      @if (event().images.length > 0) {
        <app-container [noPadding]="true">
          <app-header-image [alt]="event().title" [src]="event().getMainImage()" [additionalItems]="event().images"
                            [fullHeight]="true"/>
        </app-container>
      }

      <app-container>
        <h1 class="mt-3">{{ event().title }}</h1>

        @if (event().event_date_start) {
          <div class="flex items-center mt-2 mb-2">
            <ion-icon name="calendar"/>
            <span class="ml-2 text-gray-500">
              {{ event().event_date_start | date:'EEE dd.MM.yyyy HH:mm':'Europe/Berlin':'de-DE' }}
            </span>
            @if (event().event_date_end) {
              <span class="mx-2 text-gray-500">-</span>
              <span
                class="text-gray-500">{{ event().event_date_end | date:'EEE dd.MM.yyyy HH:mm':'Europe/Berlin':'de-DE' }}</span>
            }
          </div>
        }

        <app-timeline-entry-action-buttons [entry]="event()"/>

        @if (event().description) {
          <div id="description" class="text mt-3" [innerHTML]="event().description"></div>
        }
      </app-container>


      @if (mainLocation && hasMapLocation) {
        <div class="bg-gray-100 dark:bg-gray-900 mt-6 pt-3 pb-3">
          <app-container>
            <h4 class="pb-3">Veranstalter</h4>

            <div>
              <ion-nav-link class="cursor-pointer font-bold" [routerLink]="'/'+event().owner.url">
                @if (mainLocation.company) {
                  <div>{{ mainLocation.company }}</div>
                } @else {
                  <div>{{ event().owner.title }}</div>
                }
              </ion-nav-link>

              {{ mainLocation.street_address }}<br/>
              {{ mainLocation.zip_code }} {{ mainLocation.city }}
            </div>
          </app-container>
        </div>
        <app-map-single-location [location]="mainLocation" [title]="event().owner.title"/>
      }

    }

    @if (isOwner()) {
      <ion-fab slot="fixed" horizontal="end" vertical="bottom">
        <ion-fab-button>
          <ion-icon name="ellipsis-vertical-outline"/>
        </ion-fab-button>

        <ion-fab-list side="top">
          <ion-fab-button (click)="onClickUpdate()" data-desc="Bearbeiten">
            <ion-icon name="create"/>
          </ion-fab-button>
          <ion-fab-button (click)="onClickDelete()" data-desc="Löschen">
            <ion-icon name="trash" color="danger"/>
          </ion-fab-button>
        </ion-fab-list>
      </ion-fab>
    }
  }
</ion-content>
